import './LanguageSegmented.scss';

import { useGetLocale, useSetLocale } from '@refinedev/core';
import { Avatar, Segmented } from 'antd';
import { SegmentedOptions } from 'antd/es/segmented';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useUiContext } from '@/contexts/UiContext';
import { setDayjsLocale } from '@/dayjs.config';
import en_flag from '@/img/en.svg';
import es_flag from '@/img/es.svg';
import pt_flag from '@/img/pt.svg';

const LanguageSegmented = () => {
  const { isMobile } = useUiContext();
  const { t, i18n } = useTranslation();
  const locale = useGetLocale();
  const changeLanguage = useSetLocale();
  const currentLocale = locale();
  const menuItems: SegmentedOptions = [...(i18n.languages || [])]
    .sort((v1, v2) => v1.localeCompare(v2))
    .map((lang: string) => ({
      className: 'LanguageSegmentedOption',
      value: lang,
      icon: (
        <span>
          <Avatar size={16} src={lang == 'es' ? es_flag : lang == 'pt' ? pt_flag : en_flag} />
        </span>
      ),
      label: isMobile
        ? ''
        : lang === 'es'
          ? t('Español')
          : lang === 'pt'
            ? t('Portugués')
            : t('Ingles'),
    }));

  useEffect(() => {
    if (currentLocale) {
      setDayjsLocale(currentLocale);
    }
  }, [currentLocale]);

  return (
    <Segmented
      className="LanguageSegmented"
      shape="round"
      block
      onChange={value => {
        changeLanguage(value as string);
        setDayjsLocale(value as string);
      }}
      value={currentLocale}
      options={menuItems}
    />
  );
};

export default LanguageSegmented;
